export default "__VITE_ASSET__CAjNvrwK__"